import axios from "../../../../axios";

export default {
    namespaced: true,
    state: {
        data: null,
    },
    getters: {
        getData: (state) => state.data,
    },
    mutations: {
        SET_DATA(state, payload) {
            state.data = payload
        },
    },
    actions: {
        CHECK_DISCOUNT_COUPON(ctx, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/discount-coupon`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    },
}
